import React from "react";
import { withStyles, createStyles, WithStyles, Theme } from "@material-ui/core/styles";

import Grid from "../../lib/components/grid";

import { Defect } from "../../lib/api/defects";
import { GridColumns } from "./defectsgridsetup";

import Tooltip from "@material-ui/core/Tooltip";
import Button from "@material-ui/core/Button";

import IconAdd from "@material-ui/icons/Add";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(1),
      width: "100%",
      height: "100%",
      position: "relative",
    },
    inline: {
      display: "inline",
      position: "absolute",
      marginTop: "7px",
      marginLeft: "7px",
    },
  });

type DefectsProps = {
  data: Defect[];
  loading: boolean;
  setConfirmEditID(id: unknown): void;
  setConfirmDefect(defect: Defect): void;
} & WithStyles<typeof styles>;

export class DefectsUnstyled extends React.Component<DefectsProps, any> {
  state = {
    classes: undefined,
  };

  constructor(props) {
    super(props);

    this.state.classes = props.classes;
  }

  handleCreate = () => {
    this.props.setConfirmEditID("0");
  };

  handleEdit = (id: number) => {
    this.props.setConfirmEditID(id);
  };

  handleRemove = async (defect: Defect) => {
    this.props.setConfirmDefect(defect);
  };

  GridColumnsOverride = (column, row, arrangement, widths) => {
    return GridColumns(column, row, arrangement, widths, this.handleRemove, this.handleEdit);
  };

  render() {
    const { classes } = this.state;

    return (
      <div className={classes.root}>
        <div className={classes.inline}>
          <Tooltip title="Create new Defects">
            <div className={classes.inline}>
              <Button variant="contained" color="primary" onClick={this.handleCreate} style={{ marginBottom: "10px" }}>
                <IconAdd />
              </Button>
            </div>
          </Tooltip>
        </div>
        <Grid loading={this.props.loading} data={this.props.data} GridColumns={this.GridColumnsOverride} clearFilters={"defectsgridsetup"} />
      </div>
    );
  }
}

export default withStyles(styles)(DefectsUnstyled);
